// Keep in sync with benchling/nav/scheduled_modal/tenant_scheduled_modal.py
export const TENANT_SCHEDULED_MODAL_LAST_DISMISSED_PREFIX = 'TENANT_SCHEDULED_MODAL_LAST_DISMISSED_';

export enum TenantScheduledModal {
  GENENTECH_PTD_MODAL_KEY = 'GENENTECH_PTD_MODAL',
  GENENTECH_PTD_TRAINING_MODAL_KEY = 'GENENTECH_PTD_TRAINING_MODAL',
}
